module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mres6-727d4c50c8145aaa9f853a729ccee78e.jpg";